import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CompanyMenuService } from '@app/modules/company/services';
import { AuthService } from '@app/services/auth.service';
import { NotifyService } from '@app/services/notify.service';
import { IndexView } from '@common/views';
import { PositionsIndexTable } from '@company/services/tables/positions-table/positions-index.table';
import { BaseForm } from '@forms/base.form';
import { Job } from '@models/company/job.model';
@Component({
    templateUrl: './position-index.template.html',
    styleUrls: ['./position-index.style.scss'],
})
export class PositionIndexView extends IndexView {
    isLoading = false;

    createPermission = Job.permission.some('create');

    jobs: Job[] = [];

    constructor(
        private auth: AuthService,
        private route: ActivatedRoute,
        private notify: NotifyService,
        private router: Router,
        public table: PositionsIndexTable,
        public companyMenuService: CompanyMenuService
    ) {
        super();
        this.table.reload();
    }

    onCreate(position: Job, form: BaseForm): void {
        if (!position.isDirty()) {
            return;
        }

        this.isLoading = true;
        position
            .param('company', this.auth.company.id)
            .save()
            .then((res) => {
                form.reset();
                this.router.navigate([res.id], { relativeTo: this.route });
                this.isLoading = false;
            })
            .catch((err) => {
                this.notify.error(err.message || 'company.positions.positionSaveErrorMessage');
                this.isLoading = false;
            });
    }
}
